<template>
  <v-card
    border
    height="100%"
    class="d-flex flex-column"
  >
    <v-card-title class="my-md-4">
      <h4>
        <v-icon>mdi-file-document-outline</v-icon>
        {{ $t('legal.terms.title') }}
      </h4>
    </v-card-title>

    <v-card-text class="px-4 text-body-1">
      <p v-html="$t('legal.terms.text')" />
      <p>
        <DocumentLink
          v-if="!betaTermsAndConditionsUrl"
          type="terms"
        />
        <a
          v-else
          :href="betaTermsAndConditionsUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ $t('legal.links.terms') }}
          <v-icon
            class="ml-1 text-primary"
            size="14"
          >
            mdi-open-in-new
          </v-icon> </a
        ><br />
        <a
          :href="imprintUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ $t('legal.links.imprint')
          }}<v-icon
            class="ml-1 text-primary"
            size="14"
          >
            mdi-open-in-new
          </v-icon>
        </a>
      </p>
    </v-card-text>

    <v-card-title class="my-md-4">
      <h4>
        <v-icon>mdi-security</v-icon>
        {{ $t('legal.privacy.title') }}
      </h4>
    </v-card-title>

    <v-card-text class="px-4 text-body-1">
      <p v-html="$t('legal.privacy.text')" />
      <p>
        <DocumentLink type="privacyPolicy" /><br />
        <DocumentLink type="cookiePolicy" /><br />
        <ConsentPreferencesLink />
      </p>
    </v-card-text>

    <v-card-title class="my-md-4">
      <h4>
        <v-icon>mdi-copyright</v-icon>
        {{ $t('legal.topic.dmca.title') }}
      </h4>
    </v-card-title>

    <v-card-text class="px-4 text-body-1">
      <p>{{ $t('legal.topic.dmca.text') }}</p>
      <p>
        <a
          href="https://help.bottimmo.com/en/article/dmca-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ $t('legal.topic.dmca.link-text') }}
          <v-icon
            class="ml-1 text-primary"
            size="14"
          >
            mdi-open-in-new
          </v-icon>
        </a>
      </p>
    </v-card-text>

    <!-- TODO the documents and links are not available yet, for now only beta dpa link for US us available -->
    <template v-if="betaLinkDpa">
      <v-card-title class="my-md-4">
        <h4>
          <v-icon>mdi-file-sign</v-icon>
          {{ $t('legal.dpa.title') }}
        </h4>
      </v-card-title>

      <v-card-text class="px-4 text-body-1">
        <p v-text="$t('legal.dpa.p1')" />
        <p v-text="$t('legal.dpa.p2')" />
        <p v-text="$t('legal.dpa.p3')" />
        <p>
          <!-- TODO all documents and links are not available yet -->
          <a
            :href="betaLinkDpa"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t('legal.dpa.linkDpa') }}
            <v-icon
              class="ml-1 text-primary"
              size="14"
            >
              mdi-open-in-new
            </v-icon></a
          >
        </p>
      </v-card-text>
    </template>
  </v-card>
</template>

<script>
import brandingMixin from '@/mixins/branding'
import ConsentPreferencesLink from '@/modules/iubenda/ConsentPreferencesLink'
import DocumentLink from '@/modules/iubenda/DocumentLink'

export default {
  components: {
    DocumentLink,
    ConsentPreferencesLink,
  },

  mixins: [brandingMixin],

  props: {
    showDpaSection: {
      type: Boolean,
      default: false,
    },
    isBetaVersion: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
:deep(.v-card-title) {
  overflow-wrap: anywhere;
  white-space: normal;
}
</style>
